import { useEffect, useState } from "react"
import { PanelLoader } from "../../../../../features/ui"
import { BookmarkButton } from "../../../../../features/bookmarks"
import { RoutePath } from "../../../../../features/routes"
import { Expense, Ticket } from "../../../state/types"
import { useExpenseLoaders } from "../../../loaders/expenseLoaders"
import { useManagerState } from "../../../../manager"
import { define } from "../../../../../utils/typeUtils"
import { ExpenseList } from "./expenseList"
import { useTicketLoaders } from "../../../loaders/ticketLoaders"
import { ListLoaderWrapper } from "../../../../../features/data-types"
import { TableName } from "../../../../../tables"

const Loader = () => {
    const { currentBranch } = useManagerState()
    const branchId = define(currentBranch).id

    const [expenses, setExpenses] = useState<Expense[]>([])
    const [tickets, setTickets] = useState<Ticket[]>([])
    const [ready, setReady] = useState(false)

    const expenseLoaders = useExpenseLoaders()
    const ticketLoaders = useTicketLoaders()

    const populate = async () => {
        const { loadBranchExpenses } = expenseLoaders()
        const loadedExpenses = await loadBranchExpenses(branchId, true)
        setExpenses(loadedExpenses)
        const expenseIds = loadedExpenses.map(expense => expense.id)
        const { loadTicketsByParents } = ticketLoaders()
        setTickets(await loadTicketsByParents(expenseIds))
    }

    useEffect(() => {
        setReady(false)
        populate().then(() => setReady(true))
    }, [branchId])

    return (
        <PanelLoader
            title="Gastos"
            ready={ready}
            wide
            titleRight={<BookmarkButton routePath={RoutePath.EXPENSES} />}
        >
            <ExpenseList
                expenses={expenses}
                tickets={tickets}
            />
        </PanelLoader>
    )
}

export const ExpenseListLoader = () => (
    <ListLoaderWrapper table={TableName.EXPENSES}>
        <Loader />
    </ListLoaderWrapper>
)
